export default {
    // 流程审核接口
    approvalLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/approvalLeaveBill', params, response);
    },
    // 查询待审核流程
    queryApprovalLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryApprovalLeaveBill', params, response);
    },
    // 查询流程信息
    queryLeaveBillByCode(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryLeaveBillByCode', params, response);
    }
};
